/**
 * MHR Layout Component
 */

import { useState, ReactNode } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { APP_VERSION, BUILD_DATE, COPYRIGHT_YEAR, COMPANY_NAME } from '../../../config/version';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('mhrSidebarCollapsed');
    return saved === 'true';
  });

  const handleToggleCollapse = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem('mhrSidebarCollapsed', String(newState));
  };

  return (
    // The shared AppBar is the sticky h-12 (3rem) bar — the shell below it
    // fills the rest of the viewport (flex column, internal scroll).
    <div className="h-screen bg-gray-50 dark:bg-gray-900 flex flex-col overflow-hidden">
      <Header onMenuClick={() => setSidebarOpen(true)} />
      <div className="flex flex-1 min-h-0">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          isCollapsed={sidebarCollapsed}
          onToggleCollapse={handleToggleCollapse}
        />
        <main className="flex-1 overflow-auto p-4">{children}</main>
      </div>
      <footer className="flex-shrink-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-2 px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between text-xs text-gray-500 dark:text-gray-400 gap-1">
          <p>
            &copy; {COPYRIGHT_YEAR} {COMPANY_NAME}. All rights reserved.
          </p>
          <p>
            Version {APP_VERSION} &middot; {BUILD_DATE}
          </p>
        </div>
      </footer>
    </div>
  );
}
